import { useEffect, useRef } from "react";
import { DRYPProvider } from "./context";
import { useDRYP } from "./logics";
import { DRYPContainer, calendarClasses } from "./styles";
import { DRYPYear } from "./year";

export const DRPYear = () => {
  const contextValues = useDRYP();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    containerRef.current?.scrollBy(0, 10000);
  }, []);

  return (
    <DRYPContainer ref={containerRef} className={calendarClasses.root}>
      <DRYPProvider {...contextValues}>
        <DRYPYear />
      </DRYPProvider>
    </DRYPContainer>
  );
};
